"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NmiWebhookPayloadSchema = exports.NmiWebhookAmountsSchema = exports.NmiWebhookEmvDataSchema = exports.NmiWebhookCardSchema = void 0;
const zod_1 = require("zod");
// NMI Cloud EMV webhook payload — what NMI POSTs to /webhooks/nmi
// after a card-present transaction completes on the POI device.
//
// Signature header: `x-nmi-signature` — HMAC-SHA256 of raw body using
// the shared webhook signing key (from SSM).
exports.NmiWebhookCardSchema = zod_1.z.object({
    last4: zod_1.z.string().length(4),
    brand: zod_1.z.string(),
    entryMode: zod_1.z.enum(['chip_emv', 'contactless_emv', 'swipe', 'manual', 'online']).optional(),
    binCountry: zod_1.z.string().optional(),
});
exports.NmiWebhookEmvDataSchema = zod_1.z.object({
    applicationId: zod_1.z.string().optional(),
    applicationLabel: zod_1.z.string().optional(),
    tvr: zod_1.z.string().optional(),
    tsi: zod_1.z.string().optional(),
});
exports.NmiWebhookAmountsSchema = zod_1.z.object({
    subtotal: zod_1.z.number(),
    tip: zod_1.z.number().default(0),
    surcharge: zod_1.z.number().default(0),
    total: zod_1.z.number(),
});
exports.NmiWebhookPayloadSchema = zod_1.z.object({
    // Our internal payment id, echoed back via NMI `order_id`
    orderId: zod_1.z.string(),
    // NMI-assigned transaction id (unique, used for idempotency)
    transactionId: zod_1.z.string(),
    // NMI status code — '100' = approved
    responseCode: zod_1.z.string(),
    responseText: zod_1.z.string().optional(),
    authCode: zod_1.z.string().optional(),
    avsResponse: zod_1.z.string().optional(),
    cvvResponse: zod_1.z.string().optional(),
    card: exports.NmiWebhookCardSchema,
    emvData: exports.NmiWebhookEmvDataSchema.optional(),
    amounts: exports.NmiWebhookAmountsSchema,
    // Captured separately so callers don't have to dig into amounts
    tipAmount: zod_1.z.number().default(0),
    surchargeAmount: zod_1.z.number().default(0),
    totalAmount: zod_1.z.number(),
    currency: zod_1.z.string().length(3).default('USD'),
    terminalId: zod_1.z.string().optional(),
    timestamp: zod_1.z.string(),
});
//# sourceMappingURL=nmi-webhook.schema.js.map